module.exports = {
	SUPPORT_EMAIL: 'BoxManSupport@cimpress.com',
}
